import { APPOINTMENT } from './constants';

export const operations = {
  createAppt: 'CREATE_APPT',
  updateAppt: 'UPDATE_APPT',
  createPersonalTime: 'CREATE_TIME_BLOCK',
  editPersonalTime: 'EDIT_TIME_BLOCK',
  cancelPersonalTime: 'CANCEL_TIME_BLOCK',
  proposeNewTime: 'PROPOSE_NEW_TIME',
  acceptAppt: 'ACCEPT_APPT',
  declineAppt: 'DECLINE_APPT',
  cancelAppt: 'CANCEL_APPT',
  checkinAppt: 'CHECKIN_APPT',
  joinMeeting: 'JOIN_MEETING',
  addToCalendar: 'ADD_TO_CALENDAR',
  isLoading: 'IS_LOADING',
  backToNativePanel: 'BACK_TO_NATIVE_PANEL'
};

const LINKS_RESOURCE_PATH = 'v1/links';
const RAW_LINKS_RESOURCE_PATH = 'v1/links/raw';
const VALID_LINK_SUBSTRING_SIZE = 2;

function getVirtualMeetingDetailsURL(joinLink) {
  if (!joinLink) {
    return;
  }
  const joinLinkSubstrings = joinLink.split(LINKS_RESOURCE_PATH);
  if (joinLinkSubstrings.length !== VALID_LINK_SUBSTRING_SIZE) {
    return;
  }
  return `${joinLinkSubstrings[0]}${RAW_LINKS_RESOURCE_PATH}${joinLinkSubstrings[1]}`;
}

export function pushMessageToWebViewContainer(
  operation,
  data,
  isError = false
) {
  // Publish message only when postMessage is available from ReactNativeWebView
  if (
    typeof window === 'undefined' ||
    window.ReactNativeWebView === undefined ||
    window.ReactNativeWebView.postMessage === undefined
  ) {
    return;
  }

  if (isError) {
    return postMessage({
      error: true,
      operation,
      message: getErrorMessage(data.message)
    });
  }

  const message = {
    operation,
    error: isError
  };

  switch (operation) {
    case operations.acceptAppt:
    case operations.declineAppt:
    case operations.checkinAppt:
    case operations.createAppt:
    case operations.proposeNewTime:
    case operations.updateAppt:
      message.data = {
        id: data.id,
        name: data.name,
        startTime: data.start ? data.start : data.startTime,
        endTime: data.end ? data.end : data.endTime,
        status: data.appointmentStatus,
        locationName: getLocationName(
          data.appointmentStatus,
          data.parentLocationDisplayName,
          data.locationDisplayName
        ),
        requesters: data.requesters,
        requestees: data.requestees,
        apptConfirmationStatus: data.status,
        apptTypeCategory: data.apptType?.category
      };
      break;
    case operations.cancelAppt:
      message.data = {
        id: data.id
      };
      break;
    case operations.joinMeeting:
      message.data = {
        joinLink: data.virtualLink,
        detailsLink: getVirtualMeetingDetailsURL(
          `${data.virtualLink}&source=Webview`
        )
      };
      break;

    case operations.createPersonalTime:
    case operations.editPersonalTime:
    case operations.cancelPersonalTime:
      message.data = {
        id: data.id,
        name: data.name,
        description: data.description,
        startTime: data.start,
        endTime: data.end
      };
      break;

    case operations.addToCalendar:
      message.data = {
        url: data.url
      };
      break;

    case operations.isLoading:
      message.data = {
        loading: data.loading
      };
      break;

    case operations.backToNativePanel:
      message.data = {
        backToNativePanel: data.backToNativePanel
      };
      break;

    default:
      throw new Error(`Invalid operation: ${operation} passed`);
  }
  postMessage(message);
}

function postMessage(message) {
  window.ReactNativeWebView.postMessage(JSON.stringify(message));
}

function getLocationName(
  status,
  parentLocationDisplayName,
  locationDisplayName
) {
  if (!status) {
    return null;
  }

  if (
    status.toUpperCase() ===
      APPOINTMENT.STATUS.PENDING_APPROVAL_AND_ASSIGNMENT ||
    status.toUpperCase() === APPOINTMENT.STATUS.PENDING_ASSIGNMENT
  ) {
    // if table assignment is pending, use parent location name only
    return parentLocationDisplayName;
  }

  // if appointment is on table, attach parent location name as well
  return parentLocationDisplayName
    ? `${parentLocationDisplayName}, ${locationDisplayName}`
    : locationDisplayName;
}

function getErrorMessage(error) {
  return error?.graphQLErrors?.[0]?.message;
}
